import { Check } from "lucide-react";
import { BASE } from "@/lib/site-data";

const bullets = [
  "Our Medical Director, Dr. Harris, invented many of the leading hair restoration tools used today.",
  "Other clinics attempt to replicate the techniques we've spent decades perfecting.",
  "Far too often, we're the team correcting what someone else got wrong.",
];

export function NoShaveFacts() {
  return (
    <section className="bg-muted py-12 md:py-16">
      <div className="mx-auto max-w-3xl px-4 text-center lg:max-w-5xl lg:px-8">
        <h2 className="text-3xl font-normal text-foreground md:text-4xl lg:whitespace-nowrap">
          <strong className="font-bold">Before</strong> You Choose Your Team,{" "}
          <strong className="font-bold">Get the Facts:</strong>
        </h2>
        <div className="mt-8 flex flex-col items-center gap-8">
          <ul className="inline-block space-y-4 text-left">
            {bullets.map((text, i) => (
              <li key={i} className="flex items-start gap-3 text-base text-foreground">
                <Check className="mt-0.5 h-5 w-5 shrink-0 text-foreground" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
          <a
            href={`${BASE}/doctors/`}
            className="inline-block bg-primary px-8 py-4 text-sm font-bold tracking-wider text-primary-foreground transition hover:bg-primary/90"
          >
            Read about our doctors
          </a>
        </div>
      </div>
    </section>
  );
}
